import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, renderSlot as _renderSlot, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

import { useGlobalAuthCheck } from '@/composables/useGlobalAuthCheck';
    import AppContent from '@/components/AppContent.vue';
    import AppNavbar from '@/components/AppNavbar.vue';
    import AppShell from '@/components/AppShell.vue';
    import AppSidebar from '@/components/AppSidebar.vue';
    import AppSidebarHeader from '@/components/AppSidebarHeader.vue';
    import type { BreadcrumbItemType } from '@/types';
    import type { HTMLAttributes } from 'vue';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'AppSidebarLayout',
  props: {
    breadcrumbs: { default: () => [] },
    headerClass: {},
    contentClass: {},
    hideHeader: { type: Boolean, default: false }
  },
  setup(__props: any) {

    

    useGlobalAuthCheck();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AppShell, { variant: "sidebar" }, {
    default: _withCtx(() => [
      _createVNode(AppSidebar),
      _createVNode(AppContent, {
        variant: "sidebar",
        class: _normalizeClass(_ctx.contentClass)
      }, {
        default: _withCtx(() => [
          _createVNode(AppNavbar),
          (!_ctx.hideHeader)
            ? (_openBlock(), _createBlock(AppSidebarHeader, {
                key: 0,
                breadcrumbs: _ctx.breadcrumbs,
                "header-class": _ctx.headerClass
              }, {
                actions: _withCtx(() => [
                  _renderSlot(_ctx.$slots, "header-actions")
                ]),
                _: 3
              }, 8, ["breadcrumbs", "header-class"]))
            : _createCommentVNode("", true),
          _renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 8, ["class"])
    ]),
    _: 3
  }))
}
}

})